import { render } from "./MenuContentItemTabGroup.vue?vue&type=template&id=379e7483"
import script from "./MenuContentItemTabGroup.vue?vue&type=script&lang=js"
export * from "./MenuContentItemTabGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__